var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-button-field',{attrs:{"title":_vm.title,"is-empty":_vm.isValueEmpty,"addable":_vm.addable,"removable":_vm.removable},on:{"create":_vm.showTextEditorWithTemplateModal,"edit":_vm.showTextEditorWithTemplateModal,"delete":_vm.showRemoveTextConfirmationModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }